// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2lQ8J","header":"PatientBlock_header__3rFOh","label":"PatientBlock_label__3f2YA","option":"PatientBlock_option__o7Eui"};